// extracted by mini-css-extract-plugin
module.exports = {"root":"TenantsBlock_root__3rmsk"};